import React from 'react';
import sprintf from 'sprintf';

class SMSocialFacebookLink extends React.Component {
  constructor(props) {
    super(props);

    this.clickFbBtn = this.clickFbBtn.bind(this);
  }

  setSocialLinks() {
    const url = this.props.url;
    const fbUrl = sprintf("https://www.facebook.com/sharer/sharer.php?u=%s", url);
    return fbUrl;
  };

  clickFbBtn(e) {
    const href = this.setSocialLinks();
    const width = window.innerWidth;
    const height = window.innerHeight;
    const halfWidth = Math.floor(width / 2);
    const halfHeight = Math.floor(height / 2);
    const params = `status=0, width=${halfWidth}, height=${halfHeight}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`;

    window.open(href, 'sharer', params);

    // Google Analytics
    const gaLabel = this.props.gaLabel;
    if (typeof ga != 'function') {
      return;
    }
    ga('send', 'event', 'button', 'click', gaLabel);
  };

  render() {
    return (
      <a href="#" onClick={this.clickFbBtn} className="social-link__facebook referral__social-link-facebook">
      <i className="fa fa-facebook-square"></i>
      </a>
    );
  };
}
export default SMSocialFacebookLink;




// WEBPACK FOOTER //
// ./app/javascript/components/social/SMSocialFacebookLink.jsx